import { api } from './client';
import type {
  ScopeFormResponse,
  CreateScopeFormInput,
  AdminUpdateScopeFormInput,
  Uuid,
} from '../types/api';

export async function getScopeForm(transactionId: Uuid): Promise<ScopeFormResponse | null> {
  const res = await api.get<ScopeFormResponse | null>(`/transactions/${transactionId}/scope-form`);
  return res.data;
}

export async function createScopeForm(
  transactionId: Uuid,
  data: CreateScopeFormInput,
): Promise<ScopeFormResponse> {
  const res = await api.post<ScopeFormResponse>(`/transactions/${transactionId}/scope-form`, data);
  return res.data;
}

export async function adminUpdateScopeForm(
  transactionId: Uuid,
  data: AdminUpdateScopeFormInput,
): Promise<ScopeFormResponse> {
  const res = await api.patch<ScopeFormResponse>(
    `/transactions/${transactionId}/scope-form/admin-update`,
    data,
  );
  return res.data;
}

export async function acceptScopeForm(transactionId: Uuid): Promise<ScopeFormResponse> {
  const res = await api.post<ScopeFormResponse>(`/transactions/${transactionId}/scope-form/accept`);
  return res.data;
}
